import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

const KPICards = ({ data, loading }) => {
    const { t } = useLanguage();
    if (loading) {
        return (
            <div className="row g-3 mb-4">
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className="col-xl-3 col-md-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <div className="placeholder-glow">
                                    <span className="placeholder col-6"></span>
                                    <h2 className="placeholder col-8 mt-2" aria-label={t('metrics.loading')}></h2>
                                    <span className="placeholder col-4"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!data) return null;

    const getTrendIcon = (pct) => {
        if (!pct) return '';
        return pct > 0 ? '↑' : pct < 0 ? '↓' : '→';
    };

    const getTrendClass = (pct) => {
        if (!pct) return 'text-muted';
        return pct > 0 ? 'text-success' : pct < 0 ? 'text-danger' : 'text-muted';
    };

    return (
        <div className="row g-3 mb-4">
            {/* Total Usuarios */}
            <div className="col-xl-3 col-md-6">
                <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h6 className="text-muted mb-1" style={{fontSize: '0.85rem'}}>{t('metrics.kpi.totalUsers')}</h6>
                                <h2 className="mb-0 fw-bold">{data.total_usuarios}</h2>
                            </div>
                            <div className="bg-primary bg-opacity-10 p-2 rounded">
                                <i className="bi bi-people-fill text-primary" style={{fontSize: '1.5rem'}}></i>
                            </div>
                        </div>
                        <span className="badge bg-success bg-opacity-10 text-success">
                            {data.usuarios_activos} {t('metrics.kpi.activeUsers')}
                        </span>
                    </div>
                </div>
            </div>

            {/* Total Consultas */}
            <div className="col-xl-3 col-md-6">
                <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h6 className="text-muted mb-1" style={{fontSize: '0.85rem'}}>{t('metrics.kpi.totalQueries')}</h6>
                                <h2 className="mb-0 fw-bold">{data.total_consultas.toLocaleString()}</h2>
                            </div>
                            <div className="bg-success bg-opacity-10 p-2 rounded">
                                <i className="bi bi-chat-dots-fill text-success" style={{fontSize: '1.5rem'}}></i>
                            </div>
                        </div>
                        {data.cambio_mensual_pct !== null && (
                            <span className={`small ${getTrendClass(data.cambio_mensual_pct)}`}>
                                {getTrendIcon(data.cambio_mensual_pct)} {Math.abs(data.cambio_mensual_pct)}% {t('metrics.kpi.vsPreviousMonth')}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Promedio por Usuario */}
            <div className="col-xl-3 col-md-6">
                <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h6 className="text-muted mb-1" style={{fontSize: '0.85rem'}}>{t('metrics.kpi.avgPerUser')}</h6>
                                <h2 className="mb-0 fw-bold">{data.promedio_consultas_usuario}</h2>
                            </div>
                            <div className="bg-info bg-opacity-10 p-2 rounded">
                                <i className="bi bi-graph-up text-info" style={{fontSize: '1.5rem'}}></i>
                            </div>
                        </div>
                        <span className="small text-muted">{t('metrics.kpi.queriesPerUser')}</span>
                    </div>
                </div>
            </div>

            {/* Módulo Más Usado */}
            <div className="col-xl-3 col-md-6">
                <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h6 className="text-muted mb-1" style={{fontSize: '0.85rem'}}>{t('metrics.kpi.popularModule')}</h6>
                                <h5 className="mb-0 fw-bold" style={{fontSize: '1.1rem'}}>
                                    {data.modulo_mas_usado}
                                </h5>
                            </div>
                            <div className="bg-warning bg-opacity-10 p-2 rounded">
                                <i className="bi bi-trophy-fill text-warning" style={{fontSize: '1.5rem'}}></i>
                            </div>
                        </div>
                        <span className="small text-muted">{t('metrics.kpi.mostUsed')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KPICards;
